import React, { useState, useEffect } from "react"
import { Container, Col } from "react-bootstrap"
import AllUsers from "../../Components/Admin/Allusers"
import { SidemenuComponent } from "../../Components/Admin/Sidemenu"
import MobileUsers from "../../Components/Admin/MobileViewAllusers"
const Adminalluserspage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    // Perform an initial check
    handleResize()

    // Listen for resize events
    window.addEventListener("resize", handleResize)

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])
  return (
    <Container fluid className="px-0">
      <Col
        lg="10"
        sm="12"
        className="px-0"
        style={{ marginLeft: isMobile ? "0" : "17%" }}
      >
        {isMobile ? <MobileUsers /> : <AllUsers />}
      </Col>
    </Container>
  )
}
export default Adminalluserspage
